module.exports = "<ion-list can-swipe=\"false\">\n    <ion-item on-tap=\"$ctrl.selectState(state)\"\n              ng-repeat=\"state in $ctrl.states track by state\"\n              class=\"item-icon-right\">\n\n        <span translate>{{::state}}</span>\n\n        <i class=\"icon ion-ios-checkmark\" ng-if=\"$ctrl.selectedState == state\"></i>\n        <i class=\"icon ion-ios-circle-outline\" ng-if=\"$ctrl.selectedState != state\"></i>\n    </ion-item>\n</ion-list>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/booking-state-selection/booking-state-selection.html
// module id = 916
// module chunks = 0